import transactionCategoryConstants from 'analytics/transactionCategoryConstants';

function getAmountAnalytics (amount) {
  return {
    amount: amount || 0,
    transaction_category: amount ?
      transactionCategoryConstants.INR :
      transactionCategoryConstants.Free,
  };
}

export default getAmountAnalytics;



// WEBPACK FOOTER //
// ./src/cart/analytics/getAmountAnalytics.js